/* Sōren Pharma — comportements de la landing Protocole N°01.
   Porté depuis static/index.html. Trois responsabilités :
   canvas de micro-gouttelettes, apparition au scroll, ajout au panier Shopify. */
(function () {
  'use strict';

  /* Chaque section inclut snippets/soren-assets.liquid, donc ce fichier peut être
     référencé plusieurs fois sur la même page. Une seule initialisation suffit. */
  if (window.__sorenInit) return;
  window.__sorenInit = true;

  const reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Exécute une fois les polices chargées et une frame passée : seul moment où les
     hauteurs mesurées correspondent à ce que voit le visiteur. */
  function misePageStable(fn) {
    const polices = document.fonts ? document.fonts.ready : Promise.resolve();
    polices.then(() => requestAnimationFrame(() => requestAnimationFrame(fn)));
  }

  /* ————— Canvas : micro-gouttelettes d'huile ————— */
  function initGouttelettes(canvas) {
    const ctx = canvas.getContext('2d');
    let gouttes = [];
    let rafId = null;
    let visible = true;
    let t = 0;

    function dpr() {
      return Math.min(window.devicePixelRatio || 1, 2);
    }

    function dimensionner() {
      const d = dpr();
      const r = canvas.parentElement.getBoundingClientRect();
      canvas.width = r.width * d;
      canvas.height = r.height * d;
      ctx.setTransform(d, 0, 0, d, 0, 0);
      const n = r.width < 768 ? 34 : 78;
      gouttes = Array.from({ length: n }, () => ({
        x: Math.random() * r.width,
        y: Math.random() * r.height,
        r: 0.6 + Math.random() * 2.1,
        v: 0.06 + Math.random() * 0.28,
        ph: Math.random() * Math.PI * 2,
        fq: 0.4 + Math.random() * 0.9,
        a: 0.05 + Math.random() * 0.22,
        chaud: Math.random() < 0.3,
      }));
    }

    function dessiner() {
      const d = dpr();
      const w = canvas.width / d;
      const h = canvas.height / d;
      ctx.clearRect(0, 0, w, h);
      t += 0.008;
      for (const g of gouttes) {
        g.y -= g.v;
        g.x += Math.sin(t * g.fq + g.ph) * 0.18;
        if (g.y < -6) {
          g.y = h + 6;
          g.x = Math.random() * w;
        }
        const scintille = g.a * (0.55 + 0.45 * Math.sin(t * 1.7 + g.ph));
        ctx.beginPath();
        ctx.arc(g.x, g.y, g.r, 0, Math.PI * 2);
        /* Encre sur papier : sur fond crème, des particules claires sont invisibles.
           Le vert du logotype pour les chaudes, le lichen pour les froides. */
        ctx.fillStyle = g.chaud
          ? 'rgba(58,81,51,' + scintille.toFixed(3) + ')'
          : 'rgba(138,145,121,' + scintille.toFixed(3) + ')';
        ctx.fill();
      }
      if (visible) rafId = requestAnimationFrame(dessiner);
    }

    dimensionner();
    window.addEventListener('resize', dimensionner);
    new IntersectionObserver((entrees) => {
      visible = entrees[0].isIntersecting;
      if (visible && rafId === null) rafId = requestAnimationFrame(dessiner);
      if (!visible && rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }).observe(canvas);
    rafId = requestAnimationFrame(dessiner);
  }

  /* ————— Apparition des blocs au scroll —————
     IntersectionObserver plutôt que ScrollTrigger : ne dépend d'aucune position mesurée
     à l'avance et livre ses observations en attente au retour sur l'onglet. */
  function initReveal() {
    const blocs = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      blocs.forEach((el) => el.classList.add('vu'));
      return;
    }
    const observateur = new IntersectionObserver(
      (entrees) => {
        entrees.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('vu');
          observateur.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px' }
    );
    blocs.forEach((el) => observateur.observe(el));
  }

  /* ————— Molécule des mots-clés du hero —————
     Deux brins hélicoïdaux reliés par des barreaux, et une liaison tirée de chaque
     mot-clé vers le brin le plus proche. Le squelette est bâti ici et non dans le
     gabarit : Liquid n'a pas de sinus, et les points d'accroche dépendent de la
     position réelle des mots, que seul le navigateur connaît.

     Le viewBox du SVG est 0–100 sur les deux axes en preserveAspectRatio="none" :
     une unité vaut donc 1 % de la largeur en x, 1 % de la hauteur en y, exactement
     comme les --x/--y qui placent les mots. Conséquence à ne pas perdre de vue : le
     repère est ÉTIRÉ, une distance en unités de viewBox n'est pas une distance à
     l'écran. Toute comparaison de longueurs se fait donc en pixels (voir relierMots). */
  const HELICE = {
    centre: 50, //        axe vertical du squelette
    tours: 1.7, //        nombre de tours complets sur la hauteur
    /* Rapport largeur/hauteur d'un lobe MESURÉ À L'ÉCRAN. C'est lui qu'on tient
       constant, et non l'amplitude : le viewBox étant étiré, une amplitude fixe
       donne une hélice élancée sur un socle haut et des lentilles écrasées sur un
       socle large. 0,55 est le rapport d'une double hélice de manuel. */
    elancement: 0.55,
    haut: 4,
    bas: 96,
    echantillons: 96, //  à cette finesse de trait, la polyligne ne se distingue pas d'une courbe
    barreaux: 26,
    barreauMin: 2.4, //   sous cette largeur, près d'un croisement, le barreau ne fait qu'une tache
  };

  /* Résout l'amplitude qui donne l'élancement voulu sur ce socle-ci :
     2·A·(largeur/100) = elancement · (hauteur / tours). Bornée pour qu'un socle
     très plat ou très étroit ne produise ni un trait ni un débordement. */
  function amplitudeHelice(boite) {
    const a = 50 * HELICE.elancement * boite.height / (HELICE.tours * boite.width);
    return Math.min(Math.max(a, 6), 30);
  }

  function pointHelice(t, phase, amplitude) {
    return {
      x: HELICE.centre + amplitude * Math.sin(2 * Math.PI * HELICE.tours * t + phase),
      y: HELICE.haut + (HELICE.bas - HELICE.haut) * t,
    };
  }

  function elementSvg(nom, attributs) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', nom);
    for (const cle in attributs) el.setAttribute(cle, attributs[cle]);
    return el;
  }

  const PHASES = [0, Math.PI];

  /* Brins et barreaux. Ils dépendent de l'amplitude, donc de la forme du socle :
     redessinés seulement quand celle-ci change vraiment (voir initMolecule). */
  function tracerSquelette(svg, etat) {
    const gBrins = svg.querySelector('[data-molecule-brins]');
    const gBarreaux = svg.querySelector('[data-molecule-barreaux]');
    gBrins.textContent = '';
    gBarreaux.textContent = '';

    etat.brins = PHASES.map((phase) => {
      let d = '';
      for (let i = 0; i <= HELICE.echantillons; i++) {
        const p = pointHelice(i / HELICE.echantillons, phase, etat.amplitude);
        d += (i ? 'L' : 'M') + p.x.toFixed(2) + ' ' + p.y.toFixed(2);
      }
      const trait = elementSvg('path', { d: d, class: 'molecule-brin', 'vector-effect': 'non-scaling-stroke' });
      const lueur = elementSvg('path', { d: d, class: 'molecule-lueur', 'vector-effect': 'non-scaling-stroke' });
      gBrins.appendChild(trait);
      gBrins.appendChild(lueur);
      return { trait: trait, lueur: lueur };
    });

    for (let i = 1; i < HELICE.barreaux; i++) {
      const t = i / HELICE.barreaux;
      const a = pointHelice(t, PHASES[0], etat.amplitude);
      const b = pointHelice(t, PHASES[1], etat.amplitude);
      if (Math.abs(a.x - b.x) < HELICE.barreauMin) continue;
      gBarreaux.appendChild(elementSvg('line', {
        x1: a.x.toFixed(2), y1: a.y.toFixed(2), x2: b.x.toFixed(2), y2: b.y.toFixed(2),
        class: 'molecule-barreau', 'vector-effect': 'non-scaling-stroke',
      }));
    }
    etat.barreaux = Array.from(gBarreaux.children);
  }

  /* Liaisons : elles dépendent en plus de la position mesurée des mots, donc
     recalculées à chaque changement de dimensions. */
  function relierMots(svg, etat, boite) {
    const groupe = svg.querySelector('[data-molecule-liaisons]');
    groupe.textContent = '';

    const echX = boite.width / 100;
    const echY = boite.height / 100;
    const liaisons = [];

    svg.parentElement.querySelectorAll('.hero-mot').forEach((mot) => {
      const noeud = mot.querySelector('.hero-noeud') || mot;
      const r = noeud.getBoundingClientRect();
      if (!r.width) return;
      const nx = ((r.left + r.width / 2) - boite.left) / boite.width * 100;
      const ny = ((r.top + r.height / 2) - boite.top) / boite.height * 100;

      /* Point de brin visuellement le plus proche. La distance est mesurée en
         pixels : le viewBox étant étiré, minimiser en unités de viewBox
         accrocherait le mauvais brin dès que le socle n'est pas carré. */
      let meilleur = null;
      let minimum = Infinity;
      for (const phase of PHASES) {
        for (let i = 0; i <= HELICE.echantillons; i++) {
          const pt = pointHelice(i / HELICE.echantillons, phase, etat.amplitude);
          const dx = (pt.x - nx) * echX;
          const dy = (pt.y - ny) * echY;
          const d2 = dx * dx + dy * dy;
          if (d2 < minimum) {
            minimum = d2;
            meilleur = pt;
          }
        }
      }
      if (!meilleur) return;

      groupe.appendChild(elementSvg('line', {
        x1: nx.toFixed(2), y1: ny.toFixed(2),
        x2: meilleur.x.toFixed(2), y2: meilleur.y.toFixed(2),
        class: 'molecule-liaison', 'vector-effect': 'non-scaling-stroke',
      }));
      liaisons.push(groupe.lastChild);
    });

    return liaisons;
  }

  let molecule = null;

  function initMolecule() {
    const svg = document.querySelector('[data-molecule]');
    if (!svg) return null;

    const etat = { svg: svg, amplitude: 0, brins: [], barreaux: [], liaisons: [], surTrace: null };

    /* Un ResizeObserver plutôt qu'un écouteur `resize` : la hauteur du socle
       dépend de l'image du hero, qui arrive après le chargement de la page sans
       provoquer le moindre redimensionnement de fenêtre. Les liaisons seraient
       alors tracées vers des positions périmées.

       Tout est SYNCHRONE, sans requestAnimationFrame : dans un onglet ouvert en
       arrière-plan, Chrome ne planifie plus aucune frame et un tracé différé ne
       serait jamais exécuté — la molécule n'existerait pas au retour du visiteur.
       Le fichier prend déjà cette précaution ailleurs (voir forcerAffichage et le
       test de visibilityState dans initGsap). Un ResizeObserver s'exécute, lui,
       après le calcul de mise en page, ce qui rend les mesures ci-dessous justes. */
    let dansTrace = false;
    const dessiner = () => {
      /* Garde-fou : réécrire les enfants d'un SVG en position absolue ne change
         aucune dimension, l'observateur ne peut donc pas se rappeler lui-même.
         Le drapeau couvre le cas où une future retouche donnerait une taille au
         tracé — mieux vaut un tracé manqué qu'une boucle infinie. */
      if (dansTrace) return;
      const boite = svg.getBoundingClientRect();
      /* Masqué sous 1024 px : sans surface, toutes les divisions donneraient NaN. */
      if (!boite.width || !boite.height) return;

      dansTrace = true;
      try {
        const voulue = amplitudeHelice(boite);
        /* Les brins ne sont refaits que si la forme du socle a réellement changé.
           Les redessiner à chaque pixel de redimensionnement détacherait les
           cibles de l'animation en cours. */
        const refaits = !etat.amplitude || Math.abs(voulue - etat.amplitude) / etat.amplitude > 0.05;
        if (refaits) {
          etat.amplitude = voulue;
          tracerSquelette(svg, etat);
        }
        etat.liaisons = relierMots(svg, etat, boite);
        if (etat.surTrace) etat.surTrace(refaits);
      } finally {
        dansTrace = false;
      }
    };
    new ResizeObserver(dessiner).observe(svg.parentElement);
    dessiner();

    return etat;
  }

  /* Tracé progressif : le motif de tirets fait la longueur exacte du trait, et
     l'animation ramène le décalage à zéro — le trait se dessine de son origine
     vers sa fin. Rien n'est posé en CSS : sans JavaScript, aucun dasharray
     n'existe et tout est visible d'emblée. */
  function amorcerTrace(el) {
    const longueur = el.getTotalLength();
    gsap.set(el, { strokeDasharray: longueur, strokeDashoffset: longueur });
    return longueur;
  }

  function animerMolecule() {
    if (!molecule || !window.gsap) return;

    let introJouee = false;
    let liaisonsJouees = false;
    let lueurs = [];

    /* Lueur qui parcourt chaque brin en continu. Le tiret est court et l'écart
       occupe tout le reste : ramener le décalage de la longueur totale à zéro
       fait exactement un passage par cycle. */
    const armerLueur = () => {
      lueurs.forEach((t) => t.kill());
      lueurs = molecule.brins.map((b, i) => {
        const longueur = b.lueur.getTotalLength();
        gsap.set(b.lueur, { strokeDasharray: '7 ' + (longueur - 7), strokeDashoffset: longueur, opacity: 0.85 });
        return gsap.to(b.lueur, {
          strokeDashoffset: 0, duration: 6.5, ease: 'none', repeat: -1, delay: 2.2 + i * 3.25,
        });
      });
    };

    /* Appelé après chaque tracé. `refaits` dit si le squelette vient d'être
       reconstruit — auquel cas la lueur doit être ré-armée sur les nouveaux
       chemins, les anciens étant détachés du document. */
    const jouer = (refaits) => {
      if (!molecule.brins.length) return;

      if (!introJouee) {
        introJouee = true;
        const traits = molecule.brins.map((b) => b.trait);
        traits.forEach(amorcerTrace);
        molecule.barreaux.forEach(amorcerTrace);
        /* Les deux brins se dessinent l'un après l'autre, puis les barreaux les
           relient de haut en bas, puis les liaisons partent vers les mots :
           l'ordre raconte l'assemblage, il n'est pas décoratif. */
        gsap.timeline({ delay: 0.4 })
          .to(traits, { strokeDashoffset: 0, duration: 1.9, ease: 'power2.inOut', stagger: 0.18 }, 0)
          .to(molecule.barreaux, { strokeDashoffset: 0, duration: 0.5, ease: 'power2.out', stagger: 0.03 }, 0.6);
        armerLueur();
      } else if (refaits) {
        armerLueur();
      }

      /* Les liaisons n'existent qu'une fois l'image du hero arrivée, qui donne au
         socle sa hauteur. On les anime dès qu'elles apparaissent, une seule fois :
         les recalculs ultérieurs les laissent en place. */
      if (!liaisonsJouees && molecule.liaisons.length) {
        liaisonsJouees = true;
        molecule.liaisons.forEach(amorcerTrace);
        gsap.to(molecule.liaisons, {
          strokeDashoffset: 0, duration: 0.75, ease: 'power2.out', stagger: 0.14, delay: 1.3,
        });
      }
    };

    /* Le premier tracé est différé d'une frame par initMolecule : il a pu ne pas
       encore avoir lieu. On s'abonne donc, et on joue tout de suite si le
       squelette est déjà là. */
    molecule.surTrace = jouer;
    jouer(true);
  }

  /* ————— Projecteur sur cartes papier ————— */
  function initProjecteur() {
    document.querySelectorAll('.carte-vive').forEach((carte) => {
      carte.addEventListener('pointermove', (e) => {
        const r = carte.getBoundingClientRect();
        carte.style.setProperty('--mx', e.clientX - r.left + 'px');
        carte.style.setProperty('--my', e.clientY - r.top + 'px');
      });
    });
  }

  /* Horizon ne fait pas défiler la fenêtre : le contenu défile dans `.page-wrapper`.
     ScrollTrigger écoute `window` par défaut et ne verrait donc jamais rien bouger.
     On repère le conteneur réellement défilant, avec repli sur window si le thème
     change d'architecture. */
  function trouverScroller() {
    /* On remonte depuis la landing jusqu'au premier ancêtre qui défile, en se fiant
       UNIQUEMENT à overflow-y. Surtout pas à `scrollHeight > clientHeight` : au moment
       où ce script s'exécute, images et polices ne sont pas chargées, le conteneur
       n'est pas encore plus haut que sa zone visible, et la détection retombe alors à
       tort sur window — les triggers ne voient plus jamais rien défiler. */
    const ancre = document.querySelector('.soren-root');
    for (let el = ancre && ancre.parentElement; el && el !== document.documentElement; el = el.parentElement) {
      if (/auto|scroll/.test(getComputedStyle(el).overflowY)) return el;
    }
    return window;
  }

  /* La barre d'achat de la fiche produit est en `position: fixed` : elle ne prend
     aucune place dans le flux et recouvre donc les derniers pixels de la page,
     c'est-à-dire le pied de page. On rend cette hauteur au conteneur qui défile.

     C'est bien le scroller d'Horizon qu'on rembourre, pas <body> : le contenu ne
     défile pas dans la fenêtre mais dans `.page-wrapper` (voir trouverScroller),
     et un padding sur body n'y changerait rien.

     ResizeObserver plutôt qu'une valeur figée : la hauteur de la barre dépend du
     titre du produit, qui passe sur deux lignes sur les petits écrans, et de
     safe-area-inset-bottom, qui bouge quand la barre d'URL d'iOS se rétracte. */
  function initBarreAchat() {
    const barre = document.querySelector('.barre-achat');
    if (!barre) return;

    const scroller = trouverScroller();
    const cible = scroller === window ? document.body : scroller;

    const ajuster = () => {
      /* offsetParent nul = la barre est masquée par `md:hidden` sur grand écran.
         On rend alors la place au lieu de réserver un vide en bas de page. */
      const h = barre.offsetParent === null ? 0 : barre.offsetHeight;
      cible.style.paddingBottom = h ? h + 'px' : '';
    };

    ajuster();
    if (window.ResizeObserver) new ResizeObserver(ajuster).observe(barre);
    window.addEventListener('resize', ajuster);
  }

  /* ————— Animations GSAP ————— */
  function initGsap() {
    if (reduit || !window.gsap || !window.ScrollTrigger) {
      document.querySelectorAll('[data-hero]').forEach((el) => {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      document.getElementById('cta-flottant')?.classList.add('on');
      return;
    }
    gsap.registerPlugin(ScrollTrigger);

    const scroller = trouverScroller();
    ScrollTrigger.defaults({ scroller: scroller });

    /* Dans un onglet en arrière-plan, requestAnimationFrame est gelé et l'animation
       d'entrée resterait à opacité nulle : on affiche alors directement. */
    if (document.visibilityState === 'visible') {
      gsap.from('[data-hero]', { y: 26, opacity: 0, duration: 1.1, ease: 'power3.out', stagger: 0.12, delay: 0.15 });
      gsap.from('#hero-img', { opacity: 0, scale: 1.05, duration: 1.7, ease: 'power2.out', delay: 0.4 });
      animerMolecule();
    }

    /* Les seuils du scrub sont mesurés avec les polices de repli, sur un document plus
       court que le document final : sans ce recalcul ils tombent au mauvais endroit. */
    misePageStable(() => ScrollTrigger.refresh());

    /* Échelle de formule : remplissage séquentiel scrubbed */
    if (document.getElementById('compo')) {
      const tlCompo = gsap.timeline({
        scrollTrigger: { trigger: '#compo', start: 'top 78%', end: 'top 30%', scrub: 0.6 },
      });
      gsap.utils.toArray('.seg').forEach((seg) => {
        tlCompo.to(seg, { width: seg.dataset.w + '%', duration: parseFloat(seg.dataset.w), ease: 'none' });
      });
      tlCompo.to('.seg-label', { opacity: 1, duration: 12, ease: 'none' });
    }

    /* Manifesto : surlignage mot à mot */
    const manifesto = document.getElementById('manifesto');
    if (manifesto) {
      const unites = [];
      Array.from(manifesto.childNodes).forEach((noeud) => {
        if (noeud.nodeType === Node.TEXT_NODE) {
          const frag = document.createDocumentFragment();
          noeud.textContent.split(/(\s+)/).forEach((part) => {
            if (/^\s+$/.test(part) || part === '') {
              frag.appendChild(document.createTextNode(part));
              return;
            }
            const s = document.createElement('span');
            s.className = 'w';
            s.textContent = part;
            frag.appendChild(s);
            unites.push(s);
          });
          manifesto.replaceChild(frag, noeud);
        } else if (noeud.classList && noeud.classList.contains('pill')) {
          noeud.classList.add('w');
          unites.push(noeud);
        }
      });

      /* Le départ vient du customizer : par défaut « top 85% », soit dès que le texte
         entre par le bas de l'écran. L'ancien « top top » n'armait qu'une fois le bloc
         collé en haut, longtemps après que le texte soit lisible. */
      const wrap = document.getElementById('manifesto-wrap');
      const depart = (wrap && wrap.dataset.depart) || 'top 85%';

      const tlMani = gsap.timeline({
        scrollTrigger: { trigger: '#manifesto-wrap', start: depart, end: 'bottom bottom', scrub: 0.4 },
      });
      let pos = 0;
      unites.forEach((u) => {
        if (u.classList.contains('pill')) {
          tlMani.to(u, { opacity: 1, backgroundColor: '#3A5133', color: '#FBF5E9', borderColor: '#3A5133', duration: 0.55, ease: 'none' }, pos);
          pos += 0.3;
        } else {
          tlMani.to(u, { opacity: 1, duration: 0.3, ease: 'none' }, pos);
          pos += 0.1;
        }
      });
      tlMani.from('#manifesto-tags > span', { opacity: 0, y: 14, stagger: 0.12, duration: 0.9, ease: 'power2.out' }, pos + 0.4);
    }

    /* CTA flottant */
    const fab = document.getElementById('cta-flottant');
    if (fab && document.getElementById('protocole')) {
      ScrollTrigger.create({
        trigger: '#protocole',
        start: 'top 55%',
        onEnter: () => fab.classList.add('on'),
        onLeaveBack: () => fab.classList.remove('on'),
      });
    }
    if (fab && document.getElementById('commander')) {
      ScrollTrigger.create({
        trigger: '#commander',
        start: 'top 75%',
        onEnter: () => fab.classList.remove('on'),
        onLeaveBack: () => fab.classList.add('on'),
      });
    }

    console.info(
      '[soren] ScrollTriggers :', ScrollTrigger.getAll().length,
      '· scroller :', scroller === window ? 'window' : '.' + scroller.className
    );
  }

  /* Filet de sécurité pour le hero : au retour sur un onglet laissé en arrière-plan,
     une animation gelée peut ne jamais reprendre. */
  function forcerAffichage() {
    document.querySelectorAll('[data-hero], #hero-img').forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0 && getComputedStyle(el).opacity === '0') {
        el.style.opacity = '1';
        el.style.transform = 'none';
      }
    });
  }

  /* ————— Ajout au panier —————
     Le formulaire POST natif reste la voie de secours : si le fetch ou l'événement
     Horizon échoue pour une raison quelconque, on retombe sur /cart, qui marche toujours. */
  function initPanier() {
    document.querySelectorAll('form[data-soren-add]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const bouton = form.querySelector('button[type="submit"]');
        const libelleInitial = bouton ? bouton.textContent : '';
        if (bouton) {
          bouton.disabled = true;
          bouton.textContent = 'Ajout…';
        }

        /* [name="id"] et non input[name="id"] : sur la fiche produit, le choix de
           variante passe par un <select>. */
        const variantId = form.querySelector('[name="id"]')?.value;
        const quantite = Number(form.querySelector('[name="quantity"]')?.value || 1);

        try {
          const reponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantite }] }),
          });
          if (!reponse.ok) throw new Error('cart/add a répondu ' + reponse.status);

          /* Prévient Horizon pour qu'il rafraîchisse et ouvre son tiroir. Le module
             @shopify/events est déclaré dans l'importmap du thème. */
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          document.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: quantite }],
              promise: Promise.resolve(),
            })
          );

          if (bouton) {
            bouton.textContent = 'Ajouté';
            setTimeout(() => {
              bouton.disabled = false;
              bouton.textContent = libelleInitial;
            }, 1800);
          }
        } catch (err) {
          /* Repli sur le POST natif : HTMLFormElement.submit() ne redéclenche pas
             l'événement submit, donc pas de récursion. Shopify ajoute au panier
             côté serveur puis redirige vers /cart. */
          console.warn('[soren] ajout panier en repli sur le POST natif :', err);
          form.submit();
        }
      });
    });
  }

  /* ————— Fidélité : passerelle vers le widget BON —————
     BON Loyalty n'écrit aucun métachamp client et n'expose aucune lecture du solde :
     celui-ci ne vit que dans son iframe. La page ne peut donc pas l'afficher, elle
     se contente d'ouvrir le panneau — en cliquant le lanceur que BON injecte.

     Le bouton part masqué et n'est révélé qu'une fois le lanceur vu. Deux raisons :
     bon-loyalty.js s'injecte de façon asynchrone, et surtout le lanceur n'existe pas
     du tout tant que le programme est désactivé côté app. Sans ce garde-fou, la page
     afficherait un bouton inerte. */
  function initFidelite() {
    const bouton = document.querySelector('[data-soren-fidelite]');
    if (!bouton) return;

    const lanceur = () => document.getElementById('bon-loyalty-btn');

    function activer(cible) {
      bouton.style.display = '';
      bouton.addEventListener('click', () => cible.click());
    }

    const present = lanceur();
    if (present) {
      activer(present);
      return;
    }

    /* On guette l'arrivée du lanceur plutôt que de sonder à intervalle fixe, et on
       renonce au bout de dix secondes : passé ce délai, BON est absent ou éteint. */
    const observateur = new MutationObserver(() => {
      const cible = lanceur();
      if (!cible) return;
      observateur.disconnect();
      activer(cible);
    });
    observateur.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => observateur.disconnect(), 10000);
  }

  /* Charge un script une seule fois, quelle que soit le nombre de sections. */
  function chargerScript(src) {
    return new Promise((resoudre, rejeter) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resoudre;
      s.onerror = () => rejeter(new Error('échec de chargement : ' + src));
      document.head.appendChild(s);
    });
  }

  async function init() {
    const canvas = document.getElementById('droplets');
    if (canvas && !reduit) initGouttelettes(canvas);
    initReveal();
    initProjecteur();
    initPanier();
    initFidelite();
    initBarreAchat();
    /* Construit avant initGsap, qui vient l'animer. Le squelette est complet dès
       cet instant : si GSAP manque ou si le visiteur a demandé moins d'animation,
       il reste simplement affiché tel quel. */
    molecule = initMolecule();

    /* GSAP est chargé ici, et nulle part ailleurs : une balise <script> dans le
       snippet serait dupliquée par chaque section et chaque exécution écraserait
       window.ScrollTrigger, orphelinant les triggers déjà créés. */
    const balise = document.querySelector('script[data-gsap]');
    if (!reduit && balise && !window.gsap) {
      try {
        await chargerScript(balise.dataset.gsap);
        await chargerScript(balise.dataset.scrolltrigger);
      } catch (err) {
        console.warn('[soren] GSAP indisponible, animations au scroll désactivées :', err);
      }
    }
    initGsap();

    misePageStable(() => setTimeout(forcerAffichage, 700));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') setTimeout(forcerAffichage, 900);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
